import {CFGroupStateType} from 'module/CFGroup/reducer/CFGroupReducer'

export const selCFGroupById = (state: CFGroupStateType) => state.CFGroup.byId